import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, OnChanges, OnInit, ViewContainerRef } from '@angular/core';
import { LayerApi } from '../../../api/layer-api';
import { ESRI } from '../../../esri-loader-util';
import { InputConverter, NumberConverter } from '../../../inputConverter';
import { baseScaleIntervals } from '../../../selectionOptions';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
var LayerLabelsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LayerLabelsComponent, _super);
    function LayerLabelsComponent(_vcr, cdr, layerApi, layerService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.cdr = cdr;
        _this.layerApi = layerApi;
        _this.layerService = layerService;
        _this.showLoading = false;
        _this.layerColumns = [];
        _this.startScaleIntervals = tslib_1.__spread([
            {
                label: 'None',
                value: 0
            }
        ], baseScaleIntervals);
        _this.stopScaleIntervals = tslib_1.__spread([
            {
                label: 'None',
                value: 0
            }
        ], baseScaleIntervals);
        _this.placements = [
            { name: 'Always Horizontal', value: 'always-horizontal' },
            { name: 'Above Center', value: 'above-center' },
            { name: 'Above Left', value: 'above-left' },
            { name: 'Above Right', value: 'above-right' },
            { name: 'Above After', value: 'above-after' },
            { name: 'Above Along', value: 'above-along' },
            { name: 'Above Before', value: 'above-before' },
            { name: 'Above Start', value: 'above-start' },
            { name: 'Above End', value: 'above-end' },
            { name: 'Below Center', value: 'below-center' },
            { name: 'Below Left', value: 'below-left' },
            { name: 'Below Right', value: 'below-right' },
            { name: 'Below After', value: 'below-after' },
            { name: 'Below Along', value: 'below-along' },
            { name: 'Below Before', value: 'below-before' },
            { name: 'Below Start', value: 'below-start' },
            { name: 'Below End', value: 'below-end' },
            { name: 'Center Center', value: 'center-center' },
            { name: 'Center Left', value: 'center-left' },
            { name: 'Center Right', value: 'center-right' },
            { name: 'Center After', value: 'center-after' },
            { name: 'Center Along', value: 'center-along' },
            { name: 'Center Before', value: 'center-before' },
            { name: 'Center Start', value: 'center-start' },
            { name: 'Center End', value: 'center-end' }
        ];
        _this.includeHalo = false;
        _this.haloOptions = {
            color: 'red',
            size: 3
        };
        _this.onclose = new EventEmitter();
        _this.registerEvent('onclose', _this.onclose);
        _this.inputLayerApi = layerApi;
        return _this;
    }
    Object.defineProperty(LayerLabelsComponent.prototype, "layerId", {
        get: function () { return this._layerId; },
        set: function (layerId) { this.setLayer(layerId); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayerLabelsComponent.prototype, "uniqueLayerId", {
        get: function () {
            return this._uniqueLayerId;
        },
        set: function (value) {
            this._uniqueLayerId = value;
            if (value) {
                this.esriLayer = this.layerService.getEsriLayerByUniqueId(this._uniqueLayerId);
                this.layerId = this.esriLayer.mapcoreProps.parentId;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayerLabelsComponent.prototype, "textSymbolJSON", {
        get: function () {
            this.textSymbolEditorRef.applyChange();
            var textSymbol = this.layerSymbol;
            var textSymbolJSON = textSymbol.toJSON();
            textSymbolJSON.type = 'text';
            return textSymbolJSON;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayerLabelsComponent.prototype, "labelClassDefinition", {
        get: function () {
            this.textSymbolEditorRef.applyChange();
            var columnName = this.selectedLayerColumn.name;
            this.labelClass.labelExpression = "[" + columnName + "]";
            if (this.includeHalo) {
                this.labelClass.symbol.haloSize = this.haloOptions.size;
                this.labelClass.symbol.haloColor = this.haloOptions.color;
            }
            var labelClassDefinition = this.labelClass.toJSON();
            labelClassDefinition.labelExpressionInfo = null;
            labelClassDefinition.labelPlacement = this.labelClass.labelPlacement;
            labelClassDefinition.symbol = this.textSymbolJSON;
            return labelClassDefinition;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayerLabelsComponent.prototype, "textSymbolEditor", {
        set: function (textSymbolEditor) {
            this.textSymbolEditorRef = textSymbolEditor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayerLabelsComponent.prototype, "colorPickerRef", {
        set: function (el) { this.colorPicker = el; },
        enumerable: true,
        configurable: true
    });
    LayerLabelsComponent.prototype.apply = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.showLoading = true;
                        return [4 /*yield*/, this.setLabelingInfoForLayer(true)];
                    case 1:
                        _a.sent();
                        this.showLoading = false;
                        this.layerService.layersRefreshed.emit();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerLabelsComponent.prototype.remove = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setLabelingInfoForLayer(false)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerLabelsComponent.prototype.setLabelingInfoForLayer = function (apply) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, watch_1, _b, _c, sublayer;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                if (this.esriLayer.sublayers) {
                    watch_1 = this.mapViewRef.watch('updating', function (newValue) {
                        _this.showLoading = newValue;
                        _this.cdr.detectChanges();
                        if (!newValue) {
                            watch_1.remove();
                        }
                    });
                    try {
                        for (_b = tslib_1.__values(this.esriLayer.sublayers.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                            sublayer = _c.value;
                            if (!apply && sublayer.labelingInfo) {
                                this.esriLayer.mapcoreProps.labelingInfo = undefined;
                                sublayer.labelingInfo.length = 0;
                                delete sublayer.labelingInfo;
                            }
                            else if (apply) {
                                this.esriLayer.mapcoreProps.labelingInfo = [this.labelClassDefinition];
                                sublayer.labelingInfo = [this.labelClassDefinition];
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    this.esriLayer.refresh();
                    this.onclose.emit(true);
                }
                return [2 /*return*/];
            });
        });
    };
    LayerLabelsComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 1:
                        _a.mapViewRef = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerLabelsComponent.prototype.ngOnChanges = function () {
        if (this.labelClass && this.labelClass.symbol) {
            this.layerSymbol = this.labelClass.symbol;
        }
        this.setLayer(this.layerId);
    };
    LayerLabelsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getDefaultLabelClass()];
                    case 1:
                        _a.labelClass = _b.sent();
                        this.layerSymbol = this.labelClass.symbol;
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerLabelsComponent.prototype.clearLayerSettings = function () {
        this.layerId = null;
        this.layerColumns = null;
        this.selectedLayerColumn = null;
    };
    LayerLabelsComponent.prototype.setLayer = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layers;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._layerId = layerId;
                        if (this.labelClass && this.labelClass.symbol) {
                            this.layerSymbol = this.labelClass.symbol;
                        }
                        if (!layerId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.layerApi.getLayers([this.layerId], 'columns{alias, name}')];
                    case 1:
                        layers = _a.sent();
                        if (layers.length > 0) {
                            this.layerColumns = layers[0].columns.sort(function (a, b) {
                                if (a.alias.toLowerCase() > b.alias.toLowerCase()) {
                                    return 1;
                                }
                                else if (a.alias.toLowerCase() < b.alias.toLowerCase()) {
                                    return -1;
                                }
                                return 0;
                            });
                            this.selectedLayerColumn = this.layerColumns[0];
                        }
                        else {
                            this.clearLayerSettings();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.clearLayerSettings();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LayerLabelsComponent.prototype.getDefaultLabelClass = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, Color, TextSymbol, Font, LabelClass, symbolColor, textSymbol, font, fontsize, labelClass;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ESRI.loadModules('esri/Color', 'esri/symbols/TextSymbol', 'esri/symbols/Font', 'esri/layers/support/LabelClass')];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 4]), Color = _a[0], TextSymbol = _a[1], Font = _a[2], LabelClass = _a[3];
                        symbolColor = new Color();
                        symbolColor.setColor('#FF0000');
                        textSymbol = new TextSymbol();
                        textSymbol.color = symbolColor;
                        textSymbol.text = '';
                        textSymbol.verticalAlignment = 'middle';
                        font = new Font();
                        font.family = 'arial';
                        fontsize = 12;
                        font.size = fontsize;
                        font.weight = 'bold';
                        textSymbol.font = font;
                        labelClass = new LabelClass();
                        labelClass.labelPlacement = 'always-horizontal';
                        labelClass.symbol = textSymbol;
                        return [2 /*return*/, labelClass];
                }
            });
        });
    };
    LayerLabelsComponent.prototype.updateColorFromPicker = function (evt) {
        this.haloOptions.color = evt;
    };
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number),
        tslib_1.__metadata("design:paramtypes", [Number])
    ], LayerLabelsComponent.prototype, "layerId", null);
    return LayerLabelsComponent;
}(BaseComponent));
export { LayerLabelsComponent };
